import { Show } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { ÄhnlicheUnternehmen as ÄhnlichesUnternehmenUI } from 'components/profiles';
import React from 'react';
import { UnternehmenDto } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';

interface ÄhnlicheUnternehmenProps 
{
  unternehmen: UnternehmenDto;
}

const ÄhnlicheUnternehmen: React.FC<ÄhnlicheUnternehmenProps> = (props) =>
{
  const { unternehmen } = props;
  const { t } = useTranslation('profiles');
  
  return (
    <>
      <Show when={unternehmen.ähnlicheUnternehmen.length !== 0}>
        <ContentRow id="aehnlich" title={t('profiles:unternehmen.ähnlicheUnternehmen.label')} hideActions>
          <ÄhnlichesUnternehmenUI data={unternehmen.ähnlicheUnternehmen} />
        </ContentRow>
      </Show>
    </>
  );
};

export default ÄhnlicheUnternehmen;
